module.exports = __webpack_public_path__ + "static/media/phone_5.4a799e27.png";